import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import {
  callIssueImpersonationToken,
  type IssueImpersonationTokenInput,
  type IssueImpersonationTokenResponse,
} from '../api/issueImpersonationToken.js';

/**
 * S-07: `tenantIssueImpersonationToken` Callable を呼ぶ React Query mutation hook。
 *
 * 成功時はトークン情報を返すだけで、tenant-portal への遷移は呼出側の責務。
 * (URL 構築の env 分岐は別 helper に分離してテスト容易性を確保するため)
 */
export function useImpersonate(): UseMutationResult<
  IssueImpersonationTokenResponse,
  Error,
  IssueImpersonationTokenInput
> {
  return useMutation({
    mutationFn: (input: IssueImpersonationTokenInput) =>
      callIssueImpersonationToken(input),
  });
}
